import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Testimonial Callout",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/testimonial-callout", (props) => {
  return (
    <div className="w-grid mx-auto my-10">
      <div className="w-full rounded-lg bg-whiteLight p-7 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
        {(env.admin || !!props.image?.mediaItemUrl) && (
          <div className="col-span-1 md:col-span-3">
            <div className="w-2/3 md:w-full">
              {env.admin && !props.image?.mediaItemUrl && (
                <div className="w-full aspect-video bg-grey flex items-center justify-center type-ui">Select media</div>
              )}
              {props.image && <ResponsiveImage {...props.image} className="w-full h-auto" />}
            </div>
          </div>
        )}
        <div className="col-span-1 md:col-span-9 flex flex-col items-start justify-start gap-4">
          <EditableText
            as="p"
            store="testimonial"
            className="type-title-s md:pr-10"
            placeholder="Enter a testimonial"
          />
          <EditableText as="p" store="author" className="type-body-xl" placeholder="Enter an optional attribution" />
          {(env.admin || !!props.buttonLink?.url) && (
            <Button
              href={props.buttonLink?.url!}
              variant="primary"
              target={props.buttonLink?.target || "self"}
              className="mt-5 self-end"
            >
              {props.buttonLink?.title || "Learn More"}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
})
